<template>
  <div
    v-if="user == 6 & owner === 'mm'"
  >
    <b-row>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/light1.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">จำนวนตู้ทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ pole }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              ตู้
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/light2.svg"
              />
              <span style="font-weight: 600; font-size:20px; color: #fff; margin-left: 15px;">กำลังไฟฟ้าที่ใช้ไปทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ watt }}
            </span>
            <span
              style="position: relative; text-align:center; font-weight: 600; font-size:20px;"
            >
              วัตต์
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/light3.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; color: #fff;">แรงดันไฟฟ้าสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ volt }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              โวลต์
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/light4.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-weight: 600; font-size:20px; color: #fff;">กระแสไฟฟ้าสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ amp }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              แอมแปร์
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      pole: '',
      volt: '',
      amp: '',
      watt: '',
      owner: '',
      user: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.owner = this.userData.groupname
    this.user = this.userData.department
    this.getSumCount()
    this.interval = setInterval(() => {
      this.getSumCount()
    }, 300000)
  },
  methods: {
    getSumCount() {
      axios
        .post('/getSumLightingMM')
        .then(response => {
          this.pole = response.data[0].count_mm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.volt = response.data[0].max_volt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.amp = response.data[0].max_amp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.watt = response.data[0].total_watt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
